const parenthesesType = {
    open: 'Open',
    close: 'Close'
};

export default parenthesesType;
